module.exports = __webpack_public_path__ + "img/LS-M-16.ff746029.svg";